import { createReducer } from 'redux-starter-kit';
import { fetchSuccess } from 'actions/categories';

export default createReducer([], {
  [fetchSuccess]: (state, action) => action.payload
});
